import React, { FC, useState } from 'react';
import { Box, Button, Divider, Typography, useTheme } from '@mui/material';
import { ExpandLess, MoreVert, Person } from '@mui/icons-material';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import ReviewWrapper from '../ReviewWrapper';
import ReviewHeader from '../ReviewHeader';
import ReviewContent from '../ReviewContent';
import ReviewFooter from '../ReviewFooter';
import { useTranslation } from 'react-i18next';
import Block from '../../Block/Block';
import { CommunityManagement } from '../../../shared/interfaces/ICommunityManagement';
import ReviewText from '../ReviewText';

interface Props extends IReviewNewProps {}

const GenericReview: FC<Props> = ({
  communityManagement,
  commentingModule,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();
  const { header, position, positionText, rating, companyComment, reviewLink, blocks, text } =
    reviewEntry.review;

  const getReviewText = () => {
    if (reviewEntry.review.text) {
      return reviewEntry.review.text;
    }

    if (reviewEntry.review.reviewText) {
      return reviewEntry.review.reviewText;
    }
  };

  const getReviewUsername = () => {
    if (reviewEntry.review.username) {
      return reviewEntry.review.username;
    }

    if (reviewEntry.review.name) {
      return reviewEntry.review.name;
    }
  };

  const reviewHasUsername = () => {
    return !!getReviewUsername();
  };

  return (
    <ReviewWrapper
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={rating}
      reviewLink={reviewLink}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      dateFormat={{ comment: 'MMM yyyy' }}
      reviewEntry={reviewEntry}
    >
      {(position || positionText) && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {position && (
            <Typography
              variant="caption"
              sx={{
                color: theme.palette.text.secondary,
              }}
            >
              {position}
            </Typography>
          )}
          {positionText && (
            <Typography
              variant="caption"
              sx={{
                color: theme.palette.text.secondary,
                cursor: 'pointer',
              }}
            >
              {positionText}
            </Typography>
          )}
        </Box>
      )}
      {reviewHasUsername() && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <Person fontSize="small" />
          <Typography
            variant="body1"
            sx={{ ml: theme.spacing(1) }}
          >
            {getReviewUsername()}
          </Typography>
        </Box>
      )}
      <ReviewText text={getReviewText()} />
    </ReviewWrapper>
  );
};

export default GenericReview;
